import * as React from "react";

function CartSvg(props) {
  return (
    <svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.8 7.978h8.4c3.967 0 4.363 1.855 4.632 4.118l1.05 8.75c.338 2.87-.549 5.215-4.632 5.215H8.762c-4.095 0-4.982-2.345-4.632-5.215l1.05-8.75c.257-2.263.653-4.118 4.62-4.118z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.333 9.728V5.644c0-1.75 1.167-2.916 2.917-2.916h3.5c1.75 0 2.916 1.166 2.916 2.916v4.084M23.811 20.262H9.333"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CartSvg;
